import { useFetch } from "@common/hooks/useFetch";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "@constants";
import { getOrderAuthorization, OrderAuthorizationEnum } from "@utils/getOrderAuthorization";
import { getIsUserLinked, getProspectId, saveLinkedUser } from "@utils/storage";
import { useCreateProspect } from "./useCreateProspect";
import { linkProspectToUserRoute } from "@api-routes";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { fixUrlLanguage } from "@utils/changeLanguage";

export const useLinkProspect = () => {
    console.log("wopp wop here");
    const [linkProspectUserState, { post }] = useFetch();
    const { callCreateProspect, createProspectState } = useCreateProspect();
    const [displayChangedInfoModal, setDisplayChangedInfoModal] = useState(false);
    const { push, location } = useHistory();

    const callLinkUser = (prospectId: string) => {
        
        if (!getIsUserLinked()) {
            /*return post<ICartResponse>(linkProspectToUserRoute(prospectId)).then((userCartResponse) => {
                if (userCartResponse) {
                    const userCart = getResponseToState(userCartResponse);

                    saveLinkedUser();

                    const orderAuthorization = getOrderAuthorization(userCart);
                    const noMoreSubscriptionsAllowed = userCart.nbrAdditionalAllowedSubscriptions < 0;

                    if (noMoreSubscriptionsAllowed && orderAuthorization === OrderAuthorizationEnum.OrderImpossible) {
                        push(fixUrlLanguage(ROUTES.HOME_PAGE_URL_EN));
                    } else if (
                        noMoreSubscriptionsAllowed &&
                        orderAuthorization === OrderAuthorizationEnum.TooMuchOffer
                    ) {
                        push(fixUrlLanguage(ROUTES.CART_PAGE_URL_EN));
                    } else if (!noMoreSubscriptionsAllowed && location.pathname === fixUrlLanguage(ROUTES.SUMMARY_PAGE_URL_EN)) {
                        setDisplayChangedInfoModal(true);
                    }
                }
            });*/
        }

        return Promise.resolve();
    };

    /*const linkProspect = () => {
        const prospectId = getProspectId();
        if (prospectId) {
            return callLinkUser(prospectId);
        }

        return callCreateProspect().then((prospect) => {
            if (prospect?.prospectUuid) {
                return callLinkUser(prospect.prospectUuid);
            }

            return Promise.resolve();
        });
    };*/

    return {
        createProspectState,
        displayChangedInfoModal,
        linkProspectUserState,
        setDisplayChangedInfoModal,
    };
};
